module.exports = __webpack_public_path__ + "static/media/ic_categories_baby_stuff.cff36dc8.svg";